import { render, staticRenderFns } from "./SobreDialog.vue?vue&type=template&id=a47a5a80&scoped=true"
import script from "./SobreDialog.vue?vue&type=script&lang=js"
export * from "./SobreDialog.vue?vue&type=script&lang=js"
import style0 from "./SobreDialog.vue?vue&type=style&index=0&id=a47a5a80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47a5a80",
  null
  
)

export default component.exports